import React from 'react';
import ColorCatalog from '../components/ColorCatalog';
import ScrollAnimation from '../components/ScrollAnimation';

const ColorsPage = () => {
  return (
    <div className="min-h-screen pt-20">
      <ScrollAnimation animation="fadeInUp">
        <ColorCatalog />
      </ScrollAnimation>
    </div>
  );
};

export default ColorsPage;
